export default "__VITE_ASSET__b86d5162__"